// import React, { useState, useEffect } from 'react';
// import { BookOpen, Calendar, ArrowRight, Tag, Search } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { useLanguage } from '../context/LanguageContext';

// const ArticlesSection = () => {
//   const { language } = useLanguage(); // Get language from context
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [articles, setArticles] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [articlesCache, setArticlesCache] = useState({}); // Cache for both languages
//   const navigate = useNavigate();

//   // PHP API URL - Automatically detects localhost vs production
//   // For production: Replace with your actual domain (e.g., 'https://yourdomain.com')
//   // The code will automatically use the correct URL based on environment
//   const API_BASE_URL = process.env.REACT_APP_API_URL || 
//     (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
//       ? 'http://localhost' 
//       : window.location.origin);
  
//   // Cache duration in milliseconds (5 minutes)
//   const CACHE_DURATION = 5 * 60 * 1000;

//   const content = {
//     en: {
//       title: 'Knowledge Hub',
//       subtitle: 'Stay informed with latest updates, guides, and insights',
//       searchPlaceholder: 'Search articles...',
//       categories: ['All', 'Government Schemes', 'How-to Guides', 'Success Stories', 'News & Updates'],
//       readMore: 'Read More',
//       minRead: 'min read',
//       viewAll: 'View All Articles',
//       loading: 'Loading articles...',
//       errorMessage: 'Failed to load articles. Please try again later.',
//       noResults: 'No articles found',
//       tryDifferent: 'Try a different search term'
//     },
//     mr: {
//       title: 'ज्ञान केंद्र',
//       subtitle: 'नवीनतम अपडेट्स, मार्गदर्शक आणि माहितीसह अद्ययावत रहा',
//       searchPlaceholder: 'लेख शोधा...',
//       categories: ['सर्व', 'सरकारी योजना', 'मार्गदर्शक', 'यशोगाथा', 'बातम्या'],
//       readMore: 'अधिक वाचा',
//       minRead: 'मिनिट वाचन',
//       viewAll: 'सर्व लेख पहा',
//       loading: 'लेख लोड होत आहेत...',
//       errorMessage: 'लेख लोड करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
//       noResults: 'कोणतेही लेख सापडले नाहीत',
//       tryDifferent: 'कृपया वेगळे शोध वापरून पहा'
//     }
//   };

//   const t = content[language];

//   const categoryMap = {
//     'en': {
//       'All': 'all',
//       'Government Schemes': 'Government Schemes',
//       'How-to Guides': 'How-to Guides',
//       'Success Stories': 'Success Stories',
//       'News & Updates': 'News & Updates'
//     },
//     'mr': {
//       'सर्व': 'all',
//       'सरकारी योजना': 'Government Schemes',
//       'मार्गदर्शक': 'How-to Guides',
//       'यशोगाथा': 'Success Stories',
//       'बातम्या': 'News & Updates'
//     }
//   };

//   // Fetch articles from PHP API with caching
//   useEffect(() => {
//     const fetchArticles = async () => {
//       try {
//         const locale = language === 'mr' ? 'mr-IN' : 'en';
//         const cacheKey = `articles_${locale}`;
//         const now = Date.now();

//         // Check if we have cached data that's still fresh
//         if (articlesCache[cacheKey]) {
//           const { data, timestamp } = articlesCache[cacheKey];
//           const isExpired = now - timestamp > CACHE_DURATION;

//           if (!isExpired) {
//             // Use cached data
//             console.log(`Using cached ${locale} articles`);
//             setArticles(data);
//             setLoading(false);
//             return;
//           } else {
//             console.log(`Cache expired for ${locale}, fetching fresh data`);
//           }
//         }

//         setLoading(true);
//         setError(null);

//         // Map language code to database language name
//         const langParam = language === 'mr' ? 'Marathi' : 'English';
        
//         // Fetch articles from PHP API
//         const response = await fetch(
//           `${API_BASE_URL}/admin/api/get-blogs.php?lang=${langParam}`
//         );

//         if (!response.ok) {
//           const errorText = await response.text();
//           console.error('API Error Response:', errorText);
//           throw new Error(`Failed to fetch articles: ${response.status} ${response.statusText}`);
//         }

//         const result = await response.json();
        
//         console.log('PHP API Response:', result); // Debug log
        
//         // Check if data exists and has the expected structure
//         if (!result.success || !Array.isArray(result.data)) {
//           console.error('Unexpected API response structure:', result);
//           setArticles([]);
//           return;
//         }
        
//         // Transform PHP API data to component format
//         const transformedArticles = result.data
//           .filter(article => article && article.status === 'active') // Only active blogs
//           .map(article => {
//             // Format date
//             const dateObj = article.created_at ? new Date(article.created_at) : new Date();
//             const formattedDate = dateObj.toLocaleDateString(
//               language === 'mr' ? 'mr-IN' : 'en-US',
//               { year: 'numeric', month: 'short', day: 'numeric' }
//             );
            
//             // Calculate read time (rough estimate: 200 words per minute)
//             const wordCount = article.description ? article.description.split(/\s+/).length : 0;
//             const readTime = Math.max(1, Math.ceil(wordCount / 200));
            
//             return {
//               id: article.id,
//               title: article.title || 'Untitled',
//               excerpt: article.excerpt || article.description?.substring(0, 200) || '',
//               category: article.category || 'General',
//               date: formattedDate,
//               readTime: readTime.toString(),
//               image: article.image_url || article.image || '📄',
//               featured: article.featured || false,
//               slug: article.slug || `blog-${article.id}`
//             };
//           });

//         setArticles(transformedArticles);
        
//         // Cache the results with timestamp
//         setArticlesCache(prev => ({
//           ...prev,
//           [cacheKey]: {
//             data: transformedArticles,
//             timestamp: now
//           }
//         }));
        
//         console.log(`Fetched and cached ${transformedArticles.length} articles for ${locale}`);
//       } catch (err) {
//         console.error('Error fetching articles:', err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchArticles();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [language]); // Re-fetch when language changes

//   const filteredArticles = articles.filter(article => {
//     const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
//                          article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    
//     const matchesCategory = selectedCategory === 'all' || article.category === selectedCategory;
    
//     return matchesSearch && matchesCategory;
//   });

//   const featuredArticles = filteredArticles.filter(a => a.featured);
//   const regularArticles = filteredArticles.filter(a => !a.featured);

//   const handleArticleClick = (slug) => {
//     navigate(`/blogs/${slug}`);
//   };

//   // Loading State
//   if (loading) {
//     return (
//       <section className="articles-section" id="articles">
//         <div className="articles-container">
//           <div className="articles-header">
//             <h3>{t.title}</h3>
//             <p>{t.subtitle}</p>
//           </div>
//           <div style={{ textAlign: 'center', padding: '60px 20px' }}>
//             <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
//             <p style={{ color: '#666', fontSize: '18px' }}>{t.loading}</p>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   // Error State
//   if (error) {
//     return (
//       <section className="articles-section" id="articles">
//         <div className="articles-container">
//           <div className="articles-header">
//             <h3>{t.title}</h3>
//             <p>{t.subtitle}</p>
//           </div>
//           <div style={{ textAlign: 'center', padding: '60px 20px' }}>
//             <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
//             <p style={{ color: '#ff6b35', fontSize: '18px', marginBottom: '8px' }}>{t.errorMessage}</p>
//             <button 
//               onClick={() => window.location.reload()}
//               style={{
//                 padding: '12px 24px',
//                 background: '#ff6b35',
//                 color: 'white',
//                 border: 'none',
//                 borderRadius: '8px',
//                 cursor: 'pointer',
//                 fontSize: '16px',
//                 marginTop: '16px'
//               }}
//             >
//               {language === 'mr' ? 'पुन्हा प्रयत्न करा' : 'Retry'}
//             </button>
//           </div>
//         </div>
//       </section>
//     );
//   }

//   return (
//     <>
//       <style>{`
//         .articles-section {
//           padding: 80px 0;
//           background: #f8f9fa;
//         }

//         .articles-container {
//           max-width: 1200px;
//           margin: 0 auto;
//           padding: 0 20px;
//         }

//         .articles-header {
//           text-align: center;
//           margin-bottom: 60px;
//         }

//         .articles-header h3 {
//              font-size: 40px;
//     color: #1a1a1a;
//     margin-bottom: 16px;
//     font-weight: 700;
//     background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//         }

//         .articles-header p {
//           font-size: 18px;
//           color: #666;
//         }

//         .articles-controls {
//           display: flex;
//           gap: 20px;
//           margin-bottom: 40px;
//           flex-wrap: wrap;
//           justify-content: center;
//         }

//         .search-box {
//           flex: 1;
//           min-width: 250px;
//           max-width: 400px;
//           position: relative;
//         }

//         .search-box input {
//           width: 100%;
//           padding: 14px 20px 14px 50px;
//           border: 2px solid #e0e0e0;
//           border-radius: 50px;
//           font-size: 16px;
//           transition: all 0.3s;
//         }

//         .search-box input:focus {
//           outline: none;
//           border-color: #ff6b35;
//         }

//         .search-box svg {
//           position: absolute;
//           left: 18px;
//           top: 50%;
//           transform: translateY(-50%);
//           color: #999;
//         }

//         .category-filter {
//           display: flex;
//           gap: 12px;
//           flex-wrap: wrap;
//         }

//         .category-btn {
//           padding: 12px 24px;
//           border: 2px solid #e0e0e0;
//           background: white;
//           border-radius: 50px;
//           cursor: pointer;
//           font-size: 14px;
//           font-weight: 600;
//           transition: all 0.3s;
//           color: #666;
//         }

//         .category-btn:hover {
//           border-color: #ff6b35;
//           color: #ff6b35;
//         }

//         .category-btn.active {
//           background: #ff6b35;
//           border-color: #ff6b35;
//           color: white;
//         }

//         .articles-grid {
//           display: grid;
//           grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
//           gap: 30px;
//           margin-bottom: 40px;
//         }

//         .article-card {
//           background: white;
//           border-radius: 16px;
//           overflow: hidden;
//           box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
//           transition: all 0.3s;
//           cursor: pointer;
//         }

//         .article-card:hover {
//           transform: translateY(-8px);
//           box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
//         }

//         .article-image {
//           width: 100%;
//           height: 200px;
//           background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-size: 80px;
//           overflow: hidden;
//         }

//         .article-image img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .article-content {
//           padding: 24px;
//         }

//         .article-meta {
//           display: flex;
//           align-items: center;
//           gap: 16px;
//           margin-bottom: 12px;
//           font-size: 13px;
//           color: #999;
//         }

//         .article-category {
//           display: inline-flex;
//           align-items: center;
//           gap: 6px;
//           padding: 4px 12px;
//           background: #fff5f2;
//           color: #ff6b35;
//           border-radius: 20px;
//           font-size: 12px;
//           font-weight: 600;
//         }

//         .article-title {
//           font-size: 20px;
//           color: #1a1a1a;
//           margin-bottom: 12px;
//           font-weight: 600;
//           line-height: 1.4;
//         }

//         .article-excerpt {
//           font-size: 14px;
//           color: #666;
//           line-height: 1.6;
//           margin-bottom: 16px;
//         }

//         .article-footer {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//         }

//         .read-more-btn {
//           display: inline-flex;
//           align-items: center;
//           gap: 8px;
//           color: #ff6b35;
//           font-weight: 600;
//           font-size: 14px;
//           transition: all 0.3s;
//         }

//         .read-more-btn:hover {
//           gap: 12px;
//         }

//         .no-results {
//           text-align: center;
//           padding: 60px 20px;
//         }

//         .no-results-icon {
//           font-size: 64px;
//           margin-bottom: 20px;
//         }

//         .no-results h3 {
//           font-size: 24px;
//           color: #1a1a1a;
//           margin-bottom: 12px;
//         }

//         .no-results p {
//           font-size: 16px;
//           color: #666;
//         }

//         .view-all-btn {
//           text-align: center;
//           margin-top: 40px;
//         }

//         .view-all-btn button {
//           padding: 14px 32px;
//           background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: all 0.3s;
//         }

//         .view-all-btn button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
//         }

//         @media (max-width: 768px) {
//           .articles-header h3 {
//             font-size: 32px;
//           }

//           .articles-controls {
//             flex-direction: column;
//           }

//           .search-box {
//             max-width: 100%;
//           }

//           .articles-grid {
//             grid-template-columns: 1fr;
//           }
//         }
//       `}</style>

//       <section className="articles-section" id="articles">
//         <div className="articles-container">
//           <div className="articles-header">
//             <h3>{t.title}</h3>
//             <p>{t.subtitle}</p>
//           </div>

//           <div className="articles-controls">
//             <div className="search-box">
//               <Search size={20} />
//               <input
//                 type="text"
//                 placeholder={t.searchPlaceholder}
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>
//             <div className="category-filter">
//               {t.categories.map((cat) => (
//                 <button
//                   key={cat}
//                   className={`category-btn ${selectedCategory === categoryMap[language][cat] ? 'active' : ''}`}
//                   onClick={() => setSelectedCategory(categoryMap[language][cat])}
//                 >
//                   {cat}
//                 </button>
//               ))}
//             </div>
//           </div>

//           {filteredArticles.length === 0 ? (
//             <div className="no-results">
//               <div className="no-results-icon">🔍</div>
//               <h3>{t.noResults}</h3>
//               <p>{t.tryDifferent}</p>
//             </div>
//           ) : (
//             <>
//               {featuredArticles.length > 0 && (
//                 <div style={{ marginBottom: '40px' }}>
//                   <h4 style={{ fontSize: '24px', marginBottom: '24px', color: '#1a1a1a' }}>
//                     {language === 'mr' ? 'विशेष लेख' : 'Featured Articles'}
//                   </h4>
//                   <div className="articles-grid">
//                     {featuredArticles.map((article) => (
//                       <div
//                         key={article.id}
//                         className="article-card"
//                         onClick={() => handleArticleClick(article.slug)}
//                       >
//                         <div className="article-image">
//                           {article.image.startsWith('http') ? (
//                             <img src={article.image} alt={article.title} />
//                           ) : (
//                             article.image
//                           )}
//                         </div>
//                         <div className="article-content">
//                           <div className="article-meta">
//                             <span className="article-category">
//                               <Tag size={12} />
//                               {article.category}
//                             </span>
//                             <span>
//                               <Calendar size={12} />
//                               {article.date}
//                             </span>
//                             <span>{article.readTime} {t.minRead}</span>
//                           </div>
//                           <h4 className="article-title">{article.title}</h4>
//                           <p className="article-excerpt">{article.excerpt}</p>
//                           <div className="article-footer">
//                             <span className="read-more-btn">
//                               {t.readMore}
//                               <ArrowRight size={16} />
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               <div className="articles-grid">
//                 {regularArticles.map((article) => (
//                   <div
//                     key={article.id}
//                     className="article-card"
//                     onClick={() => handleArticleClick(article.slug)}
//                   >
//                     <div className="article-image">
//                       {article.image.startsWith('http') ? (
//                         <img src={article.image} alt={article.title} />
//                       ) : (
//                         article.image
//                       )}
//                     </div>
//                     <div className="article-content">
//                       <div className="article-meta">
//                         <span className="article-category">
//                           <Tag size={12} />
//                           {article.category}
//                         </span>
//                         <span>
//                           <Calendar size={12} />
//                           {article.date}
//                         </span>
//                         <span>{article.readTime} {t.minRead}</span>
//                       </div>
//                       <h4 className="article-title">{article.title}</h4>
//                       <p className="article-excerpt">{article.excerpt}</p>
//                       <div className="article-footer">
//                         <span className="read-more-btn">
//                           {t.readMore}
//                           <ArrowRight size={16} />
//                         </span>
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default ArticlesSection;


import React, { useState, useEffect } from 'react';
import { BookOpen, Calendar, ArrowRight, Tag, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const ArticlesSection = () => {
  const { language } = useLanguage();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [articles, setArticles] = useState([]);
  const [categories, setCategories] = useState([]); // Dynamic categories
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [articlesCache, setArticlesCache] = useState({});
  const navigate = useNavigate();

  const API_BASE_URL = process.env.REACT_APP_API_URL || 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
      ? 'http://localhost' 
      : window.location.origin);
  
  const CACHE_DURATION = 5 * 60 * 1000;

  const content = {
    en: {
      title: 'Knowledge Hub',
      subtitle: 'Stay informed with latest updates, guides, and insights',
      searchPlaceholder: 'Search articles...',
      allCategory: 'All', // Dynamic category label
      readMore: 'Read More',
      minRead: 'min read',
      viewAll: 'View All Articles',
      loading: 'Loading articles...',
      errorMessage: 'Failed to load articles. Please try again later.',
      noResults: 'No articles found',
      tryDifferent: 'Try a different search term'
    },
    mr: {
      title: 'ज्ञान केंद्र',
      subtitle: 'नवीनतम अपडेट्स, मार्गदर्शक आणि माहितीसह अद्ययावत रहा',
      searchPlaceholder: 'लेख शोधा...',
      allCategory: 'सर्व', // Dynamic category label
      readMore: 'अधिक वाचा',
      minRead: 'मिनिट वाचन',
      viewAll: 'सर्व लेख पहा',
      loading: 'लेख लोड होत आहेत...',
      errorMessage: 'लेख लोड करण्यात अयशस्वी. कृपया पुन्हा प्रयत्न करा.',
      noResults: 'कोणतेही लेख सापडले नाहीत',
      tryDifferent: 'कृपया वेगळे शोध वापरून पहा'
    }
  };

  const t = content[language];

  // Fetch articles from PHP API with caching
  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const locale = language === 'mr' ? 'mr-IN' : 'en';
        const cacheKey = `articles_${locale}`;
        const now = Date.now();

        // Check if we have cached data that's still fresh
        if (articlesCache[cacheKey]) {
          const { data, timestamp } = articlesCache[cacheKey];
          const isExpired = now - timestamp > CACHE_DURATION;

          if (!isExpired) {
            console.log(`Using cached ${locale} articles`);
            setArticles(data);
            
            // Extract unique categories from cached articles
            extractCategories(data);
            
            setLoading(false);
            return;
          } else {
            console.log(`Cache expired for ${locale}, fetching fresh data`);
          }
        }

        setLoading(true);
        setError(null);

        const langParam = language === 'mr' ? 'Marathi' : 'English';
        
        const response = await fetch(
          `${API_BASE_URL}/admin/api/get-blogs.php?lang=${langParam}`
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error('API Error Response:', errorText);
          throw new Error(`Failed to fetch articles: ${response.status} ${response.statusText}`);
        }

        const result = await response.json();
        
        console.log('PHP API Response:', result);
        
        if (!result.success || !Array.isArray(result.data)) {
          console.error('Unexpected API response structure:', result);
          setArticles([]);
          return;
        }
        
        // Transform PHP API data to component format
        const transformedArticles = result.data
          .filter(article => article && article.status === 'active')
          .map(article => {
            const dateObj = article.created_at ? new Date(article.created_at) : new Date();
            const formattedDate = dateObj.toLocaleDateString(
              language === 'mr' ? 'mr-IN' : 'en-US',
              { year: 'numeric', month: 'short', day: 'numeric' }
            );
            
            const wordCount = article.description ? article.description.split(/\s+/).length : 0;
            const readTime = Math.max(1, Math.ceil(wordCount / 200));
            
            return {
              id: article.id,
              title: article.title || 'Untitled',
              excerpt: article.excerpt || article.description?.substring(0, 200) || '',
              category: article.category || 'General',
              date: formattedDate,
              readTime: readTime.toString(),
              image: article.image_url || article.image || '📄',
              featured: article.featured || false,
              slug: article.slug || `blog-${article.id}`
            };
          });

        setArticles(transformedArticles);
        
        // Extract unique categories from articles
        extractCategories(transformedArticles);
        
        // Cache the results with timestamp
        setArticlesCache(prev => ({
          ...prev,
          [cacheKey]: {
            data: transformedArticles,
            timestamp: now
          }
        }));
        
        console.log(`Fetched and cached ${transformedArticles.length} articles for ${locale}`);
      } catch (err) {
        console.error('Error fetching articles:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  // Extract unique categories from articles
  const extractCategories = (articlesData) => {
    const uniqueCategories = [...new Set(
      articlesData
        .map(article => article.category)
        .filter(category => category && category !== 'General')
    )].sort();
    
    setCategories(uniqueCategories);
    console.log('Extracted categories:', uniqueCategories);
  };

  const filteredArticles = articles.filter(article => {
    const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesCategory = selectedCategory === 'all' || article.category === selectedCategory;
    
    return matchesSearch && matchesCategory;
  });

  const featuredArticles = filteredArticles.filter(a => a.featured);
  const regularArticles = filteredArticles.filter(a => !a.featured);

  const handleArticleClick = (slug) => {
    navigate(`/blogs/${slug}`);
  };

  // Loading State
  if (loading) {
    return (
      <section className="articles-section" id="articles">
        <div className="articles-container">
          <div className="articles-header">
            <h3>{t.title}</h3>
            <p>{t.subtitle}</p>
          </div>
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⏳</div>
            <p style={{ color: '#666', fontSize: '18px' }}>{t.loading}</p>
          </div>
        </div>
      </section>
    );
  }

  // Error State
  if (error) {
    return (
      <section className="articles-section" id="articles">
        <div className="articles-container">
          <div className="articles-header">
            <h3>{t.title}</h3>
            <p>{t.subtitle}</p>
          </div>
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
            <p style={{ color: '#ff6b35', fontSize: '18px', marginBottom: '8px' }}>{t.errorMessage}</p>
            <button 
              onClick={() => window.location.reload()}
              style={{
                padding: '12px 24px',
                background: '#ff6b35',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '16px',
                marginTop: '16px'
              }}
            >
              {language === 'mr' ? 'पुन्हा प्रयत्न करा' : 'Retry'}
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <style>{`
        .articles-section {
          padding: 80px 0;
          background: #f8f9fa;
        }

        .articles-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .articles-header {
          text-align: center;
          margin-bottom: 60px;
        }

        .articles-header h3 {
          font-size: 40px;
          color: #1a1a1a;
          margin-bottom: 16px;
          font-weight: 700;
          background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .articles-header p {
          font-size: 18px;
          color: #666;
        }

        .articles-controls {
          display: flex;
          gap: 20px;
          margin-bottom: 40px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .search-box {
          flex: 1;
          min-width: 250px;
          max-width: 400px;
          position: relative;
        }

        .search-box input {
          width: 100%;
          padding: 14px 20px 14px 50px;
          border: 2px solid #e0e0e0;
          border-radius: 50px;
          font-size: 16px;
          transition: all 0.3s;
        }

        .search-box input:focus {
          outline: none;
          border-color: #ff6b35;
        }

        .search-box svg {
          position: absolute;
          left: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: #999;
        }

        .category-filter {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .category-btn {
          padding: 12px 24px;
          border: 2px solid #e0e0e0;
          background: white;
          border-radius: 50px;
          cursor: pointer;
          font-size: 14px;
          font-weight: 600;
          transition: all 0.3s;
          color: #666;
        }

        .category-btn:hover {
          border-color: #ff6b35;
          color: #ff6b35;
        }

        .category-btn.active {
          background: #ff6b35;
          border-color: #ff6b35;
          color: white;
        }

        .articles-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 30px;
          margin-bottom: 40px;
        }

        .article-card {
          background: white;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
          transition: all 0.3s;
          cursor: pointer;
        }

        .article-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
        }

        .article-image {
          width: 100%;
          height: 200px;
          background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 80px;
          overflow: hidden;
        }

        .article-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .article-content {
          padding: 24px;
        }

        .article-meta {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 12px;
          font-size: 13px;
          color: #999;
        }

        .article-category {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 4px 12px;
          background: #fff5f2;
          color: #ff6b35;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
        }

        .article-title {
          font-size: 20px;
          color: #1a1a1a;
          margin-bottom: 12px;
          font-weight: 600;
          line-height: 1.4;
        }

        .article-excerpt {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 16px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .article-footer {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .read-more-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #ff6b35;
          font-weight: 600;
          font-size: 14px;
          transition: all 0.3s;
        }

        .read-more-btn:hover {
          gap: 12px;
        }

        .no-results {
          text-align: center;
          padding: 60px 20px;
        }

        .no-results-icon {
          font-size: 64px;
          margin-bottom: 20px;
        }

        .no-results h3 {
          font-size: 24px;
          color: #1a1a1a;
          margin-bottom: 12px;
        }

        .no-results p {
          font-size: 16px;
          color: #666;
        }

        .view-all-btn {
          text-align: center;
          margin-top: 40px;
        }

        .view-all-btn button {
          padding: 14px 32px;
          background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
          color: white;
          border: none;
          border-radius: 50px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s;
        }

        .view-all-btn button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(255, 107, 53, 0.3);
        }

        @media (max-width: 768px) {
          .articles-header h3 {
            font-size: 32px;
          }

          .articles-controls {
            flex-direction: column;
          }

          .search-box {
            max-width: 100%;
          }

          .articles-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <section className="articles-section" id="articles">
        <div className="articles-container">
          <div className="articles-header">
            <h3>{t.title}</h3>
            <p>{t.subtitle}</p>
          </div>

          <div className="articles-controls">
            <div className="search-box">
              <Search size={20} />
              <input
                type="text"
                placeholder={t.searchPlaceholder}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="category-filter">
              {/* "All" button */}
              <button
                className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
                onClick={() => setSelectedCategory('all')}
              >
                {t.allCategory}
              </button>
              
              {/* Dynamic categories from database */}
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`category-btn ${selectedCategory === cat ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {filteredArticles.length === 0 ? (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h3>{t.noResults}</h3>
              <p>{t.tryDifferent}</p>
            </div>
          ) : (
            <>
              {featuredArticles.length > 0 && (
                <div style={{ marginBottom: '40px' }}>
                  <h4 style={{ fontSize: '24px', marginBottom: '24px', color: '#1a1a1a' }}>
                    {language === 'mr' ? 'विशेष लेख' : 'Featured Articles'}
                  </h4>
                  <div className="articles-grid">
                    {featuredArticles.map((article) => (
                      <div
                        key={article.id}
                        className="article-card"
                        onClick={() => handleArticleClick(article.slug)}
                      >
                        <div className="article-image">
                          {article.image.startsWith('http') ? (
                            <img src={article.image} alt={article.title} />
                          ) : (
                            article.image
                          )}
                        </div>
                        <div className="article-content">
                          <div className="article-meta">
                            <span className="article-category">
                              <Tag size={12} />
                              {article.category}
                            </span>
                            <span>
                              <Calendar size={12} />
                              {article.date}
                            </span>
                            <span>{article.readTime} {t.minRead}</span>
                          </div>
                          <h4 className="article-title">{article.title}</h4>
                          <p className="article-excerpt">{article.excerpt}</p>
                          <div className="article-footer">
                            <span className="read-more-btn">
                              {t.readMore}
                              <ArrowRight size={16} />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="articles-grid">
                {regularArticles.map((article) => (
                  <div
                    key={article.id}
                    className="article-card"
                    onClick={() => handleArticleClick(article.slug)}
                  >
                    <div className="article-image">
                      {article.image.startsWith('http') ? (
                        <img src={article.image} alt={article.title} />
                      ) : (
                        article.image
                      )}
                    </div>
                    <div className="article-content">
                      <div className="article-meta">
                        <span className="article-category">
                          <Tag size={12} />
                          {article.category}
                        </span>
                        <span>
                          <Calendar size={12} />
                          {article.date}
                        </span>
                        <span>{article.readTime} {t.minRead}</span>
                      </div>
                      <h4 className="article-title">{article.title}</h4>
                      <p className="article-excerpt">{article.excerpt}</p>
                      <div className="article-footer">
                        <span className="read-more-btn">
                          {t.readMore}
                          <ArrowRight size={16} />
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default ArticlesSection;